import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { plans } from "@/components/offsite-demo/data";
import PlanDetail from "@/components/offsite-demo/PlanDetail";
import { useOffsite } from "./OffsiteLayout";

export default function OffsitePlan() {
  const { planId } = useParams();
  const navigate = useNavigate();
  const { brief } = useOffsite();
  const plan = plans.find((p) => p.id === planId);

  useEffect(() => {
    window.scrollTo({ top: 0 });
    if (plan) document.title = `${plan.name} | qwip offsites`;
  }, [plan]);

  if (!plan) {
    return (
      <div className="min-h-screen bg-background flex flex-col items-center justify-center gap-6 px-4 text-center">
        <p className="font-funnel font-bold text-2xl text-foreground">
          that plan is not in this demo.
        </p>
        <button
          onClick={() => navigate("/offsite-demo/plans")}
          className="rounded-full bg-primary text-primary-foreground px-6 py-3 text-sm hover:bg-primary/90 transition-colors"
        >
          back to the three plans
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <PlanDetail plan={plan} brief={brief} onBack={() => navigate("/offsite-demo/plans")} />
    </div>
  );
}
